/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { font, colors, spacing, breakpoints } from '@chegg-ui/theme';
import { Accordion } from '@chegg-ui/accordion';
import { SecondaryLink } from '@chegg-ui/link';
import styled from 'styled-components';
export var footerImageHeight = 130;
export var FooterContainer = styled.div.withConfig({
  componentId: "fysmtz-0"
})(["font-family:", ";font-weight:", ";font-size:", ";color:", ";position:relative;border-top:1px solid ", ";padding:2rem 2rem ", "px 2rem;background-color:", ";@media only screen and (max-width:", "){border:0;padding:", " ", " ", "px ", ";background-color:", ";}"], font.family["default"], font.weight.bold, font.size.px12, colors.dark, colors.greyLight, footerImageHeight, colors.transparent, breakpoints.md.max, spacing.px48, spacing.px8, footerImageHeight, spacing.px8, colors.greyXlight);
export var FooterContent = styled.div.withConfig({
  componentId: "fysmtz-1"
})(["max-width:1200px;margin:0 auto;"]); // we need to ensure these background images don't overlap footer links, as doing so introduces false positive a11y contrast issues

export var BackgroundLeft = styled.img.withConfig({
  componentId: "fysmtz-2"
})(["position:absolute;left:0;bottom:0;height:", "px;"], footerImageHeight);
export var BackgroundRight = styled.img.withConfig({
  componentId: "fysmtz-3"
})(["position:absolute;bottom:0;right:0;height:", "px;width:387px;@media only screen and (max-width:", "){display:none;}"], 2 * footerImageHeight, breakpoints.md.max);
export var FooterImages = styled.div.withConfig({
  componentId: "fysmtz-4"
})(["display:flex;align-content:center;margin-top:2rem;& > a + *{margin-left:2rem;}@media only screen and (max-width:", "){flex-direction:column-reverse;align-items:center;}"], breakpoints.md.max);
export var LogoImages = styled.div.withConfig({
  componentId: "fysmtz-5"
})(["display:flex;align-items:center;"]);
export var FooterImageLink = styled.a.withConfig({
  componentId: "fysmtz-6"
})(["margin:0 ", ";"], spacing.px16);
export var Copyright = styled.p.withConfig({
  componentId: "fysmtz-7"
})(["color:", ";font-size:", ";margin-top:2rem;@media only screen and (max-width:", "){text-align:center;color:", ";}"], colors.grey, font.size.px12, breakpoints.md.max, colors.dark);
export var SmallerLink = styled(SecondaryLink).withConfig({
  componentId: "fysmtz-8"
})(["font-size:", ";&#ot-sdk-btn.ot-sdk-show-settings{font-size:", ";background:transparent;border:0 none;padding:0;color:inherit;line-height:inherit;&:hover{background:transparent;color:inherit;}}"], font.size.px12, font.size.px12);
export var FooterLinkTitle = styled.h2.withConfig({
  componentId: "fysmtz-9"
})(["font-family:", ";font-weight:", ";font-size:", ";margin:0;"], font.family["default"], font.weight.bold, font.size.px12);
export var FooterFlexBox = styled.div.withConfig({
  componentId: "fysmtz-10"
})(["display:flex;justify-content:space-between;"]);
export var FooterFlexCell = styled.div.withConfig({
  componentId: "fysmtz-11"
})(["margin:0 0.5rem;flex:1 1 0px;"]);
export var DoubleWidthFooterFlexCell = styled(FooterFlexCell).withConfig({
  componentId: "fysmtz-12"
})(["flex-grow:2;"]);
export var FooterLinkList = styled.ul.withConfig({
  componentId: "fysmtz-13"
})(["list-style:none;padding:0;margin:", " 0;width:100%;"], spacing.px8);
export var TwoColumnLinkList = styled(FooterLinkList).withConfig({
  componentId: "fysmtz-14"
})(["column-count:2;"]);
export var FooterLinkListItem = styled.li.withConfig({
  componentId: "fysmtz-15"
})(["margin-bottom:", ";"], spacing.px4);
export var StyledAccordion = styled(Accordion).withConfig({
  componentId: "fysmtz-16"
})(["& > h2 > button{background-color:", ";}"], colors.greyXlight);
export var MobileFooterLinkTitle = styled.h2.withConfig({
  componentId: "fysmtz-17"
})(["font-family:", ";font-size:", ";font-weight:", ";margin:0;margin-right:auto;"], font.family["default"], font.size.px18, font.weight.medium);
export var MobileFooterLinkList = styled.ul.withConfig({
  componentId: "fysmtz-18"
})(["list-style:none;padding:", " ", ";margin:", " 0;width:100%;"], spacing.px8, spacing.px16, spacing.px8);
export var AccordionHeader = styled.div.withConfig({
  componentId: "fysmtz-19"
})(["display:flex;align-items:center;"]);
export var MobileFooterLinkListItem = styled.li.withConfig({
  componentId: "fysmtz-20"
})(["margin-bottom:", ";& > #ot-sdk-btn.ot-sdk-show-settings{font-size:", ";background:transparent;border:0 none;padding:0;color:inherit;line-height:inherit;&:hover{background:transparent;color:inherit;}}"], spacing.px4, font.size.px14);